var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconBill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#202326",
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.25 20.5c0 .69-.56 1.25-1.25 1.25H5.25c-.69 0-1.25-.56-1.25-1.25V4.25C4 3.56 4.56 3 5.25 3h8.857c.332 0 .65.132.884.366l4.893 4.893c.234.234.366.552.366.883V20.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.25 9.25h-5C14.56 9.25 14 8.69 14 8V3M7.292 12.037c.366.48.944.753 1.548.729.95 0 1.72-.578 1.72-1.29 0-.711-.768-1.288-1.717-1.288-.948 0-1.718-.577-1.718-1.29 0-.712.77-1.289 1.718-1.289a1.85 1.85 0 0 1 1.549.73M8.843 12.766v.859M8.843 6.75v.859M12.125 14.875h5M7.75 18.625h9.375"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBill);
export default __webpack_public_path__ + "static/media/iconBill.986d69a1a255271fe0474e6166b76895.svg";
export { ForwardRef as ReactComponent };